<div class="toast mb-3 sticky" [ngClass]="className" role="alert" aria-live="assertive" aria-atomic="true" data-delay="3000">  
  <div class="toast-header">
    <strong class="mr-auto">{{toast.title}}</strong>
    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="toast-body">
    {{toast.content}}
  </div>
</div>
